import { render, staticRenderFns } from "./check_create.vue?vue&type=template&id=b98dc432&scoped=true"
import script from "./check_create.vue?vue&type=script&lang=js"
export * from "./check_create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98dc432",
  null
  
)

export default component.exports